import { makeRequest, SADUKA_TRANSPORT_PREFIX } from 'cityads-v3/utils/apiUtils';
import config from 'cityads-v3/config';

export const GET_DATA = "home/GET_DATA";
export const GET_DATA_SUCCESS = "home/GET_DATA_SUCCESS";
export const GET_DATA_FAIL = "home/GET_DATA_FAIL";
export const GET_CONVERSIONS_DATA = "home/GET_CONVERSIONS_DATA";
export const GET_CONVERSIONS_DATA_SUCCESS = "home/GET_CONVERSIONS_DATA_SUCCESS";
export const GET_CONVERSIONS_DATA_FAIL = "home/GET_DATA_FAIL";
export const GET_TOP_WMS_DATA = "home/GET_TOP_WMS_DATA";
export const GET_TOP_WMS_DATA_SUCCESS = "home/GET_TOP_WMS_DATA_SUCCESS";
export const GET_TOP_WMS_DATA_FAIL = "home/GET_TOP_WMS_DATA_FAIL";
export const GET_TOP_OFFERS_DATA = "home/GET_TOP_OFFERS_DATA";
export const GET_TOP_OFFERS_DATA_SUCCESS = "home/GET_TOP_OFFERS_DATA_SUCCESS";
export const GET_TOP_OFFERS_DATA_FAIL = "home/GET_TOP_OFFERS_DATA_FAIL";
export const GET_NEW_AND_POP_OFFERS_DATA = "home/GET_NEW_AND_POP_OFFERS_DATA";
export const GET_NEW_AND_POP_OFFERS_DATA_SUCCESS = "home/GET_NEW_AND_POP_OFFERS_DATA_SUCCESS";
export const GET_NEW_AND_POP_OFFERS_DATA_FAIL = "home/GET_NEW_AND_POP_OFFERS_DATA_FAIL";
export const GET_TOP_NEWS_DATA = "home/GET_TOP_NEWS_DATA";
export const GET_TOP_NEWS_DATA_SUCCESS = "home/GET_TOP_NEWS_DATA_SUCCESS";
export const GET_TOP_NEWS_DATA_FAIL = "home/GET_TOP_NEWS_DATA_FAIL";

export function getStatCorpData() {
  return makeRequest(config.STAT_URL + '/api/get_corp_data', {
    types: [GET_DATA, GET_DATA_SUCCESS, GET_DATA_FAIL],
    options: {
      credentials: 'include'
    },
  });
}

export function getConversionsData() {
  return makeRequest(`${SADUKA_TRANSPORT_PREFIX}/chart/conversion`, {
    types: [GET_CONVERSIONS_DATA, GET_CONVERSIONS_DATA_SUCCESS, GET_CONVERSIONS_DATA_FAIL],
    options: {
      credentials: 'include'
    },
  });
}

export function getTopWMsData() {
  return makeRequest(`${SADUKA_TRANSPORT_PREFIX}/chart/top_wm`, {
    types: [GET_TOP_WMS_DATA, GET_TOP_WMS_DATA_SUCCESS, GET_TOP_WMS_DATA_FAIL],
    options: {
      credentials: 'include'
    },
  });
}

export function getTopOffersData() {
  return makeRequest(`${SADUKA_TRANSPORT_PREFIX}/chart/top_offers`, {
    types: [GET_TOP_OFFERS_DATA, GET_TOP_OFFERS_DATA_SUCCESS, GET_TOP_OFFERS_DATA_FAIL],
    options: {
      credentials: 'include'
    },
  });
}

export function getNewAndPopOffersData() {
  return makeRequest(`${SADUKA_TRANSPORT_PREFIX}/chart/main_offers`, {
    types: [GET_NEW_AND_POP_OFFERS_DATA, GET_NEW_AND_POP_OFFERS_DATA_SUCCESS, GET_NEW_AND_POP_OFFERS_DATA_FAIL],
    options: {
      credentials: 'include'
    },
  });
}

export function getTopNewsData() {
  return makeRequest(`${SADUKA_TRANSPORT_PREFIX}/news/main`, {
    types: [GET_TOP_NEWS_DATA, GET_TOP_NEWS_DATA_SUCCESS, GET_TOP_NEWS_DATA_FAIL],
    options: {
      credentials: 'include'
    },
  });
}
